<template>
  <el-dialog :visible.sync="visibleProxy" :title="$t('오더톡 전환 절감액')" width="420px" append-to-body>
    <div class="saving-body">
      <div class="saving-value">{{ formatCurrency(value) }}</div>
      <p>{{ $t('현재 차감 내역의 30%를 자체 채널 전환 가능 금액으로 계산했습니다.') }}</p>
      <p>{{ $t('매장별 실제 전환율과 광고 운영 정책은 운영 설정이 추가되면 분리 적용됩니다.') }}</p>
    </div>
    <span slot="footer">
      <el-button size="small" @click="visibleProxy = false">{{ $t('닫기') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    visibleProxy: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      },
    },
  },
  methods: {
    formatCurrency(value) {
      return `${Number(value || 0).toLocaleString()}원`
    },
  },
}
</script>

<style scoped>
.saving-body {
  color: var(--color-text-regular);
  font-size: 14px;
  line-height: 1.6;
}

.saving-value {
  margin-bottom: 12px;
  color: var(--color-primary-dark);
  font-size: 28px;
  font-weight: 700;
}
</style>
